import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/components/pages/Login'
import FirstLogin from '@/components/pages/FirstLogin'
import Scout from '@/components/pages/scouts/Scout'
import ScoutTop from '@/components/pages/scouts/ScoutTop'
import ScoutSearch from '@/components/pages/scouts/ScoutSearch'
import ScoutSearchResult from '@/components/pages/scouts/ScoutSearchResult'
import ScoutContents from '@/components/templates/ScoutContents'
import ScoutUnderReview from '@/components/pages/scouts/ScoutUnderReview'
import ScoutExcluded from '@/components/pages/scouts/ScoutExcluded'
import ScoutCreate from '@/components/pages/scouts/ScoutCreate'
import ScoutScouted from '@/components/pages/scouts/ScoutScouted'
import ScoutLiked from '@/components/pages/scouts/ScoutLiked'
import ScoutRecommended from '@/components/pages/scouts/ScoutRecommended'
import ScoutReservation from '@/components/pages/scouts/ScoutReservation'
import Applicant from '@/components/pages/applicant/Applicant'
import ApplicantTop from '@/components/pages/applicant/ApplicantTop'
import ApplicantBulkMessage from '@/components/pages/applicant/ApplicantBulkMessage'
import ApplicantDetail from '@/components/pages/applicant/ApplicantDetail'
import ApplicantPrintPreview from '@/components/pages/applicant/ApplicantPrintPreview'
import Setting from '@/components/templates/Setting'
import SettingMemberAttributes from '@/components/pages/settings/SettingMemberAttributes'
import SettingScoutTemplates from '@/components/pages/settings/SettingScoutTemplates'
import SettingSelections from '@/components/pages/settings/SettingSelections'
import SettingAccounts from '@/components/pages/settings/SettingAccounts'
import SettingAccountPassword from '@/components/pages/settings/SettingAccountPassword'
import SettingMessageTemplates from '@/components/pages/settings/SettingMessageTemplates'
import SettingScoutTemplateRegister from '@/components/pages/settings/SettingScoutTemplateRegister'
import SettingScoutTemplateEdit from '@/components/pages/settings/SettingScoutTemplateEdit'
import SettingApplicantColumns from '@/components/pages/settings/SettingApplicantColumns'
import SettingApplicantAutoReplySelection from '@/components/pages/settings/SettingApplicantAutoReplySelection'
import SettingMessageTemplateRegister from '@/components/pages/settings/SettingMessageTemplateRegister'
import SettingMessageTemplateEdit from '@/components/pages/settings/SettingMessageTemplateEdit'
import SettingAccountRegister from '@/components/pages/settings/SettingAccountRegister'
import SettingAccountEdit from '@/components/pages/settings/SettingAccountEdit'
import SettingAutoLikedContents from '@/components/pages/settings/SettingAutoLikedContents'
import SettingAutoLikedTop from '@/components/pages/settings/SettingAutoLikedTop'
import SettingAutoLikedSearchRegister from '@/components/pages/settings/SettingAutoLikedSearchRegister'
import SettingAutoLikedSearchEdit from '@/components/pages/settings/SettingAutoLikedSearchEdit'
import SettingIpAddress from '@/components/pages/settings/SettingIpAddress'
import Preview from '@/components/templates/Preview'
import PreviewJobEditTop from '@/components/pages/preview/PreviewJobEditTop'
import PreviewJobEdit from '@/components/pages/preview/PreviewJobEdit'
import PreviewJobConfirmTop from '@/components/pages/preview/PreviewJobConfirmTop'
import PreviewForSp from '@/components/pages/preview/PreviewForSp'
import PreviewJobConfirm from '@/components/pages/preview/PreviewJobConfirm'
import AdmPreviewClientJobEditExaminationRequest from '@/components/pages/preview/AdmPreviewClientJobEditExaminationRequest'
import AdmPreviewClientJobEditExaminationApproval from '@/components/pages/preview/AdmPreviewClientJobEditExaminationApproval'
import Interview from '@/components/pages/interview/Interview'
import InterviewTop from '@/components/pages/interview/InterviewTop'
import InterviewPreview from '@/components/pages/interview/InterviewPreview'
import InterviewSettings from '@/components/pages/interview/InterviewSettings'
import InterviewRegister from '@/components/pages/interview/InterviewRegister'
import InterviewEdit from '@/components/pages/interview/InterviewEdit'
import Dashboard from '@/components/pages/dashboard/Dashboard'
import DashboardTop from '@/components/pages/dashboard/DashboardTop'
import Dummy from '@/components/pages/dummy/Dummy'
import DummyTop from '@/components/pages/dummy/DummyTop'
import NotFound from '@/components/pages/NotFound'
import InternalServerError from '@/components/pages/InternalServerError'

Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/scouts',
      component: Scout,
      children: [
        {
          path: '',
          name: 'scoutTop',
          component: ScoutTop
        },
        {
          path: 'excluded_members',
          name: 'scoutExcluded',
          component: ScoutExcluded
        },
        {
          path: 'contracts/:contractId/jobs/:jobId/users',
          name: 'scoutContents',
          component: ScoutContents,
          children: [
            {
              path: 'search',
              name: 'scoutSearch',
              component: ScoutSearch,
              props: true
            },
            {
              path: 'search_results',
              name: 'scoutSearchResult',
              component: ScoutSearchResult
            },
            {
              path: 'under_review',
              name: 'scoutUnderReview',
              component: ScoutUnderReview
            },
            {
              path: 'create',
              name: 'scoutCreate',
              component: ScoutCreate,
              props: true
            },
            {
              path: 'scouted',
              name: 'scoutScouted',
              component: ScoutScouted
            },
            {
              path: 'liked',
              name: 'scoutLiked',
              component: ScoutLiked
            },
            {
              path: 'recommended',
              name: 'scoutRecommended',
              component: ScoutRecommended
            },
            {
              path: 'reservations',
              name: 'scoutReservation',
              component: ScoutReservation
            },
            {
              path: 'reservations/:reservationId',
              name: 'scoutCreateReservation',
              component: ScoutCreate,
              props: true
            }
          ]
        }
      ]
    },
    {
      path: '/applicants',
      component: Applicant,
      children: [
        {
          path: '',
          name: 'applicantTop',
          component: ApplicantTop
        },
        {
          path: 'bulk_message',
          name: 'applicantBulkMessage',
          component: ApplicantBulkMessage,
          props: true
        },
        {
          path: ':entryId',
          name: 'applicantDetail',
          component: ApplicantDetail,
          props: true
        }
      ]
    },
    {
      path: '/applicants/:entryId/print_preview',
      name: 'applicantPrintPreview',
      component: ApplicantPrintPreview
    },
    {
      path: '/settings',
      name: 'settings',
      component: Setting,
      children: [
        {
          path: 'member_attributes',
          name: 'settingMemberAttributes',
          component: SettingMemberAttributes
        },
        {
          path: 'selections',
          name: 'settingSelections',
          component: SettingSelections
        },
        {
          path: 'accounts',
          name: 'settingAccounts',
          component: SettingAccounts
        },
        {
          path: 'accounts/:id',
          name: 'settingAccountEdit',
          component: SettingAccountEdit
        },
        {
          path: 'account_register',
          name: 'settingAccountRegister',
          component: SettingAccountRegister
        },
        {
          path: 'account_password',
          name: 'settingAccountPassword',
          component: SettingAccountPassword
        },
        {
          path: 'applicant_columns',
          name: 'settingApplicantColumns',
          component: SettingApplicantColumns
        },
        {
          path: 'applicant_auto_reply',
          name: 'settingApplicantAutoReplySelection',
          component: SettingApplicantAutoReplySelection
        },
        {
          path: 'auto_liked',
          component: SettingAutoLikedContents,
          children: [
            {
              path: '',
              name: 'settingAutoLikedTop',
              component: SettingAutoLikedTop
            },
            {
              path: 'jobs/:jobId/search',
              name: 'settingAutoLikedSearchRegister',
              component: SettingAutoLikedSearchRegister
            },
            {
              path: 'jobs/:jobId/search/:conditionId',
              name: 'settingAutoLikedSearchEdit',
              component: SettingAutoLikedSearchEdit
            }
          ]
        },
        {
          path: 'message_templates',
          name: 'settingMessageTemplates',
          component: SettingMessageTemplates
        },
        {
          path: 'message_templates/:id',
          name: 'settingMessageTemplateEdit',
          component: SettingMessageTemplateEdit
        },
        {
          path: 'message_template_register',
          name: 'settingMessageTemplateRegister',
          component: SettingMessageTemplateRegister
        },
        {
          path: 'scout_templates',
          name: 'settingScoutTemplates',
          component: SettingScoutTemplates
        },
        {
          path: 'scout_template_register',
          name: 'settingScoutTemplateRegister',
          component: SettingScoutTemplateRegister
        },
        {
          path: 'scout_templates/:id',
          name: 'settingScoutTemplateEdit',
          component: SettingScoutTemplateEdit
        },
        {
          path: 'ip',
          name: 'settingIpAddress',
          component: SettingIpAddress
        }
      ]
    },
    {
      path: '/preview',
      name: 'preview',
      component: Preview,
      children: [
        {
          path: 'unpublished_jobs',
          name: 'previewJobEditTop',
          component: PreviewJobEditTop
        },
        {
          path: 'published_jobs',
          name: 'previewJobConfirmTop',
          component: PreviewJobConfirmTop
        }
      ]
    },
    {
      path: '/preview/unpublished_jobs/:jobId',
      name: 'previewJobEdit',
      component: PreviewJobEdit
    },
    {
      path: '/preview/published_jobs/:jobId',
      name: 'previewJobConfirm',
      component: PreviewJobConfirm
    },
    {
      path: '/preview_sp/unpublished_jobs/:jobId',
      name: 'previewJobSp',
      component: PreviewForSp,
      props: { edit: true }
    },
    {
      path: '/preview_sp/published_jobs/:jobId',
      name: 'confirmPreviewJobSp',
      component: PreviewForSp,
      props: { edit: false }
    },
    {
      path: '/interviews',
      component: Interview,
      children: [
        {
          path: '',
          name: 'interviewTop',
          component: InterviewTop
        },
        {
          path: ':interviewCountermeasureId/interview_settings',
          name: 'interviewSettings',
          component: InterviewSettings
        },
        {
          path: 'countermeasure_register',
          name: 'interviewRegister',
          component: InterviewRegister
        },
        {
          path: ':interviewCountermeasureId',
          name: 'interviewEdit',
          component: InterviewEdit
        }
      ]
    },
    {
      path: '/interviews/:interviewCountermeasureId/preview',
      name: 'interviewPreview',
      component: InterviewPreview
    },
    {
      path: '/dashboard',
      component: Dashboard,
      children: [
        {
          path: '',
          name: 'dashboardTop',
          component: DashboardTop
        }
      ]
    },
    {
      path: '/first_login',
      component: FirstLogin
    },
    {
      path: '/dummy',
      component: Dummy,
      children: [
        {
          path: '',
          name: 'dummyTop',
          component: DummyTop
        }
      ]
    },
    {
      path: '*',
      component: NotFound
    },
    {
      path: '/500',
      component: InternalServerError
    },
    {
      path: '/adm/preview/prepublish/company/:companyId/job/:jobId',
      name: 'admPreview',
      component: PreviewJobEdit
    },
    {
      path: '/adm/preview_sp/prepublish/company/:companyId/jobs/:jobId',
      name: 'admPreviewJobSp',
      component: PreviewForSp,
      props: { edit: true }
    },
    {
      path: '/adm/preview/company/:companyId/jobs/:jobId',
      name: 'admConfirmJobPreview',
      component: PreviewJobConfirm
    },
    {
      path: '/adm/preview_sp/company/:companyId/jobs/:jobId',
      name: 'admConfirmPreviewJobSp',
      component: PreviewForSp,
      props: { edit: false }
    },
    {
      path: '/adm/preview/client/company/:companyId/jobs/:jobEditId/examination/request',
      name: 'admPreviewClientJobEditExamination',
      component: AdmPreviewClientJobEditExaminationRequest
    },
    {
      path: '/adm/preview/client/company/:companyId/jobs/:jobEditId/examination/approval',
      name: 'admPreviewClientJobEditApproval',
      component: AdmPreviewClientJobEditExaminationApproval
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    // https://router.vuejs.org/ja/guide/advanced/scroll-behavior.html
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
